import { API } from "@swivl-mono/api-helper";
import { GenericTableRowInterface, MemberPermission, ReviewGetType, ReviewInterface } from "@swivl-mono/types";

import { Member } from "../../../Models/Member/Member.Current";

// Helper function to extract locationIds from MemberPermission
function extractLocationIds(locationPermission: MemberPermission, groups: any): number[] {
  if (!locationPermission.locations) return [];

  const { locations } = locationPermission;

  // If orgWide, return empty array (no filtering)
  if (locations.orgId) return [];

  // Extract locationIds from groups and individual locations
  let locationIds: number[] = [];

  // Add locations from selected groups
  if (locations.groupIds && groups) {
    locations.groupIds.forEach((groupId) => {
      // Find group in array by id
      const group = Array.isArray(groups) ? groups.find((g) => g.id === groupId) : groups[groupId];
      if (group && group.locations) {
        locationIds.push(...group.locations.map((loc: any) => loc.id));
      }
    });
  }

  // Add individual locations
  if (locations.locationIds) {
    locationIds.push(...locations.locationIds);
  }
  return [...new Set(locationIds)]; // Remove duplicates
}

const SERVER_ADDRESS = "https://swivl-analytics.herokuapp.com";

export const fetchNLPData = async (orgId: number, startDay: string, endDay: string) => {
  const response = await fetch(`${SERVER_ADDRESS}/api/nlp/${orgId}/${startDay}/${endDay}`);
  return response.json();
};

export const fetchUserData = async (orgId: number, startDay: string, endDay: string) => {
  const response = await fetch(`${SERVER_ADDRESS}/api/user/${orgId}/${startDay}/${endDay}`);
  return response.json();
};

export async function fetchGenericTableRows(
  tableId: string,
  startDate: string,
  endDate: string,
  locationPermission?: MemberPermission,
  groups?: any
): Promise<GenericTableRowInterface[]> {
  try {
    const orgId = Member.orgId!;
    const locationIds = locationPermission ? extractLocationIds(locationPermission, groups) : [];
    const constraints = locationIds.length ? { locationId: locationIds } : {};

    const fetchedRows = await API.Tables.queryTable(orgId, tableId, startDate, endDate, constraints);

    const columnConstraints = { isHeading: true };
    const formatDate = (date: Date) => date.toISOString().split("T")[0];
    const getTodayDate = () => formatDate(new Date());
    const columnNamesRow = await API.Tables.queryTable(1, tableId, "2024-12-01", getTodayDate(), columnConstraints);
    if (columnNamesRow.length > 0) {
      const columnNames = Object.values(columnNamesRow[0]);
      const updatedRows = fetchedRows.map((row) => {
        const updatedRow: GenericTableRowInterface = {
          ...row
        };
        for (let i = 0; i < 75; i++) {
          const oldKey = `c${String(i + 1).padStart(2, "0")}`;
          const newKey = columnNames[i + 8];
          updatedRow[newKey] = row[oldKey];
          delete updatedRow[oldKey];
        }
        return updatedRow;
      });
      return updatedRows;
    }
    return fetchedRows;
  } catch (error) {
    console.error("Error querying table: ", error);
    throw error;
  }
}

export async function fetchReviews(orgId: number, type: ReviewGetType): Promise<ReviewInterface[]> {
  try {
    const reviews = await API.Reviews.getReviews(orgId, type);
    return reviews;
  } catch (error) {
    console.error("Error fetching reviews:", error);
    return [];
  }
}
